//#region [IMPORT]

import React from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// === COMPONENTS ===
import { Spacer } from 'components/Spacer';

//#endregion

//-----------------------------------------------------------------
export function DocumentPlaceholder( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const {
    length = 3,
  } = props;

  const theme = useTheme();

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
      display  : '',
      variant  : 'primary',
      borderRadius: '0.5rem',
      width: '100%',
      margin: 0,
      marginBottom: '1rem',
      border         : '5px dotted',
      borderColor    : theme.palette.primary.alt[theme.palette.mode],
    },
    header: {
      boxShadow: '-0.5em 0  0.01em' + theme.palette.primary.main,
      padding: '1rem',
      backgroundColor: theme.palette.primary.alt.main,
      color: theme.palette.primary.contrastText,
      height: '4rem',
      zIndex: 5,
    },
    content: {
      display: 'inline-block',
      margin: 0,
      padding: '1rem',
      height: 'fit-content',
      width: '100%',
      overflowY: 'auto',
    },
    blocks: {
      height: '100%',
      width: '100%',
      overflowY: 'auto',
    }
  }

  const CONTAINER = {
    sx  : _styles.container,
    key : 'placeholder',
    id  : 'placeholder',
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box { ...CONTAINER } >
        <Spacer height={ length * 5 + 'rem' } />
      </Box>
    )
  }

  //#endregion

  return display();
}